export const blogPosts = [
  {
    slug: 'como-elegir-el-salon-perfecto',
    title: 'Cómo elegir el salón perfecto para tus XV años',
    excerpt:
      'Capacidad, ubicación, servicios incluidos y horarios: aquí está la checklist completa antes de firmar el contrato.',
    image: 'https://picsum.photos/seed/blog1/700/450',
    date: '2026-01-12',
    category: 'Salones',
    content:
      'Elegir el salón es la primera gran decisión de la fiesta. Considera la capacidad real de invitados, si incluye mobiliario, cocina, estacionamiento y horario de música. Pide siempre el contrato por escrito y visita el lugar en el horario en que se realizará tu evento.',
  },
  {
    slug: 'tendencias-vestidos-xv-anos',
    title: 'Tendencias en vestidos de XV años para este año',
    excerpt:
      'Colores pastel, corte sirena y textura de tul: descubre lo que están eligiendo las quinceañeras esta temporada.',
    image: 'https://picsum.photos/seed/blog2/700/450',
    date: '2026-02-03',
    category: 'Vestidos',
    content:
      'Este año los tonos pastel y los vestidos con capas de tul dominan las pasarelas de XV años. También se ha vuelto tendencia el "vestido de cambio" para bailar más cómoda durante la fiesta.',
  },
  {
    slug: 'presupuesto-realista-para-xv',
    title: 'Cómo armar un presupuesto realista para tu fiesta de XV',
    excerpt:
      'Te compartimos un desglose por categoría para que sepas cuánto destinar a cada proveedor sin excederte.',
    image: 'https://picsum.photos/seed/blog3/700/450',
    date: '2026-03-18',
    category: 'Presupuesto',
    content:
      'Un buen punto de partida es destinar entre 35% y 40% del presupuesto al salón y banquete, 15% a vestuario, 15% a entretenimiento y el resto a decoración, fotografía y detalles.',
  },
  {
    slug: 'ideas-barra-de-dulces',
    title: '10 ideas para una barra de dulces inolvidable',
    excerpt:
      'Desde algodones de azúcar hasta chocolate fuente: inspírate con estas ideas para sorprender a tus invitados.',
    image: 'https://picsum.photos/seed/blog4/700/450',
    date: '2026-04-02',
    category: 'Barras',
    content:
      'Combina texturas y colores acorde a tu paleta de XV años. Las barras de chocolate fuente, algodones de azúcar de sabores y mini postres personalizados nunca fallan.',
  },
];

export const getPostBySlug = (slug) => blogPosts.find((p) => p.slug === slug);
